import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { departmentSchema as schema } from '../../_validationSchema';
import { departmentAction as actions } from '../../_action/department.action';
import { department_model as model } from '../../_model';
import { departmentConstants as constants } from '../../_constants';
import { branchConstants as branch_constants } from '../../_constants';

import { useSelector } from 'react-redux';

const Department = (props) => {
  const { t } = props;

  const header = { name: 'Department', icon: 'cubes' };
  const reducer = useSelector((state) => state.departmentOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'department';
  const menuCode = 'M_ASSET_MODEL';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'DepartmentName' },
    { title: t('branch'), field: 'BranchCode' },
  ];
  let useService = () => {
    return [schema, actions, model, constants, branch_constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);
  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(Department);
